import React, { useState } from "react"
import cx from "classnames"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import { isString } from "@/utils"

import {
  formatFacetName,
  checkFacetData,
  getAvailableOptionsFields,
} from "@/components/ProductDetail/v3/SuperSkuOption/utils"
import SuperSkuOptionSetButtons from "@/components/ProductDetail/v3/SuperSkuOption/SuperSkuOptionSetButtons"

import toolTipIcon from "@/public/icons/super-sku-tooltip.svg"
import Styles from "@/components/ProductDetail/v3/SuperSkuOption/index.module.scss"

const SuperSkuOption = props => {
  const {
    i18n = {},
    options = {},
    tooltipdata = {},
    curroptions: currOptions = {},
    selectoption,
    className = "",
    variantOptions,
    facetLabels,
    selectMoreTooltipHandler,
  } = props

  const [isActive, setIsActive] = useState("")

  const handleChange = (value, facet, dropdownName) => {
    if (value !== currOptions[facet]) {
      selectoption(value, facet, dropdownName)
    }
  }

  const handleTooltipMouseOver = (e, title, tooltipContent) => {
    const {
      target: { className },
    } = e
    if (className) setIsActive(e.target.className)
    const mouseoverTitle = (title + " mouseover").toLowerCase()
    selectMoreTooltipHandler(mouseoverTitle, false, tooltipContent)
  }

  const availableOptions = getAvailableOptionsFields({
    options,
    currOptions,
    variantOptions,
  })

  const showSuperSku = () => {
    if (!options) return false

    return Object.entries(options).some(facet => {
      const [, facetValues = []] = facet
      const values = facetValues?.filter(e => isString(e))

      return checkFacetData(facet) && values?.length > 1
    })
  }

  const styleClass = showSuperSku()
    ? cx("options-selector", className)
    : "hide-options"

  return (
    <div className={Styles.superSkuOption}>
      <div className={styleClass}>
        <div className="options-selector__options">
          {Object.entries(options).map((facet, i) => {
            const [field = "", facetValues = []] = facet
            const values = facetValues.filter(e => isString(e))

            const value = currOptions[field]?.toString()
            const isShowOption = values.length > 1

            if (checkFacetData(facet) && isShowOption) {
              return (
                <div className="options-selector__option" key={i}>
                  <div className="options-selector__heading">
                    <span>{formatFacetName({ field, facetLabels })}</span>
                    <img
                      tabIndex={0}
                      src={toolTipIcon?.src}
                      alt={i18n.toolTip}
                      className={facet[0]}
                      onMouseLeave={e =>
                        e.target.className ? setIsActive("") : ""
                      }
                      onMouseOver={e =>
                        handleTooltipMouseOver(
                          e,
                          formatFacetName({ field, facetLabels }),
                          tooltipdata[facet[0]]
                        )
                      }
                      onFocus={e =>
                        e.target.className
                          ? setIsActive(e.target.className)
                          : ""
                      }
                      onBlur={e => (e.target.className ? setIsActive("") : "")}
                    />
                    <span className="selectedSpanValue">{value}</span>
                    {isActive === field &&
                    Object.prototype.hasOwnProperty.call(tooltipdata, field) ? (
                      <ToolTip message={tooltipdata[field]} />
                    ) : (
                      ""
                    )}
                  </div>
                  <SuperSkuOptionSetButtons
                    field={field}
                    data={values}
                    variantOptions={variantOptions}
                    value={value}
                    availableOptions={availableOptions}
                    onChange={val =>
                      handleChange(
                        val,
                        field,
                        formatFacetName({ field, facetLabels })
                      )
                    }
                  />
                </div>
              )
            }
          })}
        </div>
      </div>
    </div>
  )
}

export default SuperSkuOption
